module.exports = __webpack_public_path__ + "static/media/18ECA52.fcd8d8c0.jpg";